import { jwtDecode } from "jwt-decode";

export function TokenValidateExpiration(token) {
  if (!token) {
    return false;
  }

  try {
    const decodedToken = jwtDecode(token);
    const now = Date.now() / 1000; // Convert to seconds

    if (decodedToken.exp < now) {
        console.log("Token ha expirado") // Token ha expirado
        alert("La sesión ha expirado, por favor inicie sesión de nuevo");
        localStorage.removeItem("token");
        window.location.href = '/';
        return;
    }
    //console.log("Token valido"); // Token sigue siendo válido
  } catch (error) {
    console.log("Error en la decodificación"); // Error durante la decodificación, token inválido
  }
}